module.exports = __webpack_public_path__ + "img/file.07837d90.jpg";